/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeForwardIcon16Solid = forwardRef('ArrowRoundTimeForwardIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13 1.78a1 1 0 1 1 2 0v4.224a1 1 0 0 1-1 1h-3.764a1 1 0 0 1 0-2h1.767a5 5 0 1 0 .52 5.128 1 1 0 1 1 1.809.853A7 7 0 1 1 13 3.1V1.78Z" })));
});
